<div class="image-button" >
    <img [src]="'./assets/images/icons/' + (isInvalid() ? 'icon-image-missing.svg' : (photo ? 'icon-image-uploaded.svg' : 'icon-image-upload.svg'))"
         (click)="clickImage()"/>

    <img [id]="'image_' + name" style="display: none">
    <input *ngIf="!photo" class="custom-file-input" type="file" [ngClass]="{'small':photo}"
           [id]="'input_' + name"
           accept="image/jpg, image/jpeg, image/png"
           (change)="processFile( $event)" >

</div>
